import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { ref, storage, query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy, serverTimestamp, uploadBytesResumable, getDownloadURL } from '../../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import Select from "react-select";
import Swal from "sweetalert2";
import "react-loading-skeleton/dist/skeleton.css";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // CSS bawaan tema


const Setupjadwal = () => {
    const navigate = useNavigate();
    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'image'],
            ['clean'],
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'link', 'image'
    ];
    const akses = [
        { value: 'Semua', label: 'Semua' },
        { value: 'Pd', label: 'Peserta Didik' },
        { value: 'Pendidik', label: 'Pendidik / Guru' },
        { value: 'Operator', label: 'Operator' },

    ];
    const status = [
        { value: 'Aktif', label: 'Aktif' },
        { value: 'Tidak Aktif', label: 'Tidak Aktif' }

    ];
    const [hari, sethari] = useState([]);
    const [pembelajaran, setpembelajaran] = useState([]);
    let totalJamPembelajaran = 0;
const [totaljam, setTotalJam] = useState(0);
    const [formData, setFormData] = useState({
        min_jam: 0,
        max_jam: 0,
        hari: "Senin",
        status: "Aktif"

    });

    const [formDataJamPembelajaran, setFormDataJamPembelajaran] = useState({
        hari: 0,
        id_sethari:0,
        id:0,
        list:[],
    });

    const [isEditing, setIsEditing] = useState(false);

    const [refrashaktif, setRefrashaktif] = useState(1);

    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [progress, setProgress] = useState(0);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setImage(file);
        setPreview(URL.createObjectURL(file));
    };

    const handleUpload = () => {
        if (!image) return;

        const decoded = jwtDecode(localStorage.getItem("authToken"));
        const storageRef = ref(storage, `pengumuman/${decoded.npsn}/${image.name}`);
        const uploadTask = uploadBytesResumable(storageRef, image);

        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                setProgress(prog);
            },
            (error) => console.log(error),
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    setFormData((prev) => ({
                        ...prev,
                        img: downloadURL,
                    }));
                });
            }
        );
    };

    const handleChangeisi = (value) => {
        setFormData({
            ...formData, isi: value
        })
    };

    const getDataRefrensi = useCallback(async () => {
        console.log(localStorage.getItem('authToken'))

        try {
            // Kirim request ke server dengan header level user
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refjadwal/getharijadwal`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch kelas");
            } const data = await response.json();

            sethari(data.hari)
            setpembelajaran(data.pembelajaran)
            console.log(data)

        } catch (error) {
            Swal.fire("Error!", error.message || 'Something went wrong', "error");
        }
    }, []);

    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
            console.error("Token required");
            return; // Jika tidak ada token, hentikan eksekusi
        }

        try {
            // Decode payload dari token JWT
        } catch (error) {
            console.error("Invalid token:", error);
            navigate('/login'); // Jika token tidak valid, arahkan ke halaman login
            return;
        }


    }, [navigate]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refjadwal/getharijadwal`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch kelas");
                }

                const data = await response.json();
                console.log(data)

                sethari(data.hari);
                setpembelajaran(data.pembelajaran);
                let totalJam = 0;
                for (const hariItem of data.hari) {
                    const jumlah = hariItem.list.filter(j => j.jenis === "pembelajaran").length;
                    totalJam += jumlah;
                }
                setTotalJam(totalJam);


                // Bersihkan DataTable dulu kalau sudah ada
                if ($.fn.dataTable.isDataTable(".tablef")) {
                    $(".tablef").DataTable().destroy();
                }

                $(".tablef").DataTable({
                    data: data.pembelajaran,
                    columns: [
                        { data: null, render: (data) => `<b>${data.nama_guru}</b>` },
                        { data: null, render: (data) => `<b>${data.jumlah_mapel}</b>` },
                        { data: null, render: (data) => `<b>${data.jumlah_kelas}</b>` },
                    ],
                    dom: "<'row'<'col-9'f><'col-3'B>><'row'<'col-12'tr>><'row'<'col-10'p><'col-2'i>>",
                    language: {
                        search: "",
                        lengthMenu: "_MENU_",
                        emptyTable: "Belum memiliki data",
                        loadingRecords: "Loading....",
                        zeroRecords: "Belum memiliki data",
                    },
                });

            } catch (error) {
                Swal.fire("Error!", error.message || 'Something went wrong', "error");
            }
        };

        fetchData();
    }, [refrashaktif]);

    $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        if (rowData) {
            handleEdit(rowData);
        } else {
            console.error("Data tidak ditemukan.");
        }
    });
    // Event listener untuk tombol Delete menggunakan SweetAlert2
    $(document).on("click", ".delete-btn", function (e) {
        e.preventDefault();
        let id = $(this).data("id"); // documentId dari Firestore

        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteDoc(doc(db, "madding", id)); // misalnya dari koleksi "pengumuman"

                    Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                    setRefrashaktif(refrashaktif+1);
                } catch (error) {
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                    console.error("Delete error:", error);
                }
            }
        });
    });

    // Handle perubahan input form
    const handleChange = (e) => {
        const { name, value } = e.target;
        let jam_max = 0;

        if (name === "min_jam") {
            if (formData.max_jam <= value) {
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: value,
                    max_jam: value
                }));
            } else {
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: value,
                }));
            }

        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }

        console.log(formData)
    };



    // Buka modal untuk edit data
    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData)
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refjadwal/inputsethari`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log(result.message);
            if (!response.ok) {
                Swal.fire("Error!", "Terjadi kesalahan saat menyimpan jadwal.", "error");
            } else {
                setFormData({
                    min_jam: 0,
                    max_jam: 0,
                    hari: "",
                    status: "Aktif"

                });
                Swal.fire("Berhasil!", "Jadwal berhasil disimpan!", "success");
                document.getElementById('btnTutupModal').click();
                setRefrashaktif(refrashaktif+1);
            }

        } catch (error) {
            console.error("Terjadi kesalahan:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat menyimpan jadwal.", "error");
        }

    };
    const handleSubmitjamPembalajaran = async (e) => {
        e.preventDefault();
        console.log({ jam: formDataJamPembelajaran })
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refjadwal/inputjamPembelajaran`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify({ jam: formDataJamPembelajaran.list }),
            });

            const result = await response.json();
            console.log(result.message);
            if (!response.ok) {
                Swal.fire("Error!", "Terjadi kesalahan saat menyimpan jadwal.", "error");
            } else {
                setFormData({
                    min_jam: 0,
                    max_jam: 0,
                    hari: "",
                    status: "Aktif"

                });
                Swal.fire("Berhasil!", "Jadwal berhasil disimpan!", "success");
                document.getElementById('btnTutupModal').click();
                setRefrashaktif(refrashaktif+1);
            }

        } catch (error) {
            console.error("Terjadi kesalahan:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat menyimpan jadwal.", "error");
        }

    };


    const handleChangeKases = (selectedOptions) => {
        if (!selectedOptions) return;

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;

        setFormData((prevData) => ({
            ...prevData,
            akses: selectedData.value,
        }));

        console.log("Updated Form Data:", formData);
    };

    const getStatusButtonClass = (status) => {
        if (status === "Aktif") return "btn-success";
        if (status === "Tidak Aktif") return "btn-warning";
        return "btn-danger"; // jika status null / belum di-setting
    };
    const handleJamChange = (index, field, value) => {
    const newItems = [...formDataJamPembelajaran.list];
    newItems[index] = {
        ...newItems[index],
        [field]: value,
    };

    setFormDataJamPembelajaran(prev => ({
        ...prev,
        list: newItems,
    }));
};
 const handleTambahJam = () => {
    const newItem = {
        id: `${formDataJamPembelajaran.id_sethari}-${formDataJamPembelajaran.list.length + 1}`,
        id_sethari: formDataJamPembelajaran.id_sethari,
        hari: formDataJamPembelajaran.hari,
        jam_mulai: '',
        jam_selesai: '',
        jenis: 'Pembelajaran',
    };

    setFormDataJamPembelajaran(prev => ({
        ...prev,
        list: [...prev.list, newItem]
    }));

    console.log({
        ...formDataJamPembelajaran,
        list: [...formDataJamPembelajaran.list, newItem]
    });
};

const handleHapusJam = (index) => {
    const newItems = formDataJamPembelajaran.list.filter((_, i) => i !== index);

    setFormDataJamPembelajaran(prev => ({
        ...prev,
        list: newItems
    }));
};

    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12"></div>
                        <div className="card">
                            <div className="card-body pc-component">
                                <h5 className="mb-3">Pengaturan Jadwal Pembelajaran</h5>
                                <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Hari Efektif</a>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <a className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" href="#jampembelajaran" role="tab" aria-controls="pills-profile" aria-selected="false" tabindex="-1">Jam Pembelajaran</a>
                                    </li>
                                    <li className="nav-item" role="presentation"><a className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false" tabindex="-1">Pembelajaran</a>
                                    </li>

                                    <li className="nav-item" role="presentation"><a className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" href="#genrate" role="tab" aria-controls="genrate" aria-selected="false" tabindex="-1">Genrate Jadwal</a>
                                    </li>
                                </ul>
                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade active show" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                        <div className="table-responsive">
                                            <table className="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Hari</th>
                                                        <th>Nimimal jam</th>
                                                        <th>Maximal jam</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Array.isArray(hari) && hari?.map((item) => (
                                                        <tr>
                                                            <td>{item.nama}</td>
                                                            <td>{item.min_jam}</td>
                                                            <td>{item.max_jam}</td>
                                                            <td>{item.status ?? "Belum diSetting"}</td>
                                                            <td>
                                                                <a
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#modalDaftarTarget"
                                                                    onClick={() => {
                                                                        setFormData({
                                                                            ...item,
                                                                            hari: item.nama
                                                                        });
                                                                        console.log(formData)
                                                                    }}
                                                                    className={`btn btn-icon ${getStatusButtonClass(item.status)}`}
                                                                >
                                                                    <i className="ti ti-settings"></i>
                                                                </a>
                                                            </td>

                                                        </tr>
                                                    ))}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="jampembelajaran" role="jampembelajaran" aria-labelledby="pills-contact-tab">
                                        <div className="table-responsive">
                                            <table className="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Hari</th>
                                                        <th>Mulai</th>
                                                        <th>Selesai</th>
                                                        <th>Jenis</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Array.isArray(hari) &&
                                                        hari
                                                            .filter((datahari) => datahari.status === 'Aktif') // Hanya yang status-nya Aktif
                                                            .map((datahari, index) => (
                                                                <React.Fragment key={index}>
                                                                    <tr className="table-info">
                                                                        <td colSpan="4"><b>{datahari.nama}</b></td>
                                                                        <td><a
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#jampembelajaranmodal"
                                                                            onClick={() => {
                                                                                setFormDataJamPembelajaran(datahari)
                                                                                console.log(formDataJamPembelajaran)
                                                                            }}
                                                                            className={`btn btn-icon btn-primary text-white`}
                                                                        >
                                                                            <i className="ti ti-settings"></i>
                                                                        </a></td>
                                                                    </tr>

                                                                    {Array.isArray(datahari.list) && datahari.list.length > 0 ? (
                                                                        datahari.list.map((item, idx) => (
                                                                            <tr key={idx}>
                                                                                <td>{idx + 1}</td>
                                                                                <td>{item.jam_mulai.slice(0, 5)}</td>
                                                                                <td>{item.jam_selesai.slice(0, 5)}</td>
                                                                                <td>{item.jenis}</td>
                                                                                <td>

                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="5" className="text-muted">Tidak ada data</td>
                                                                        </tr>
                                                                    )}
                                                                </React.Fragment>
                                                            ))}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                                        <div className="table-responsive">
                                            <table className="table table-hover tablef">
                                                <thead>
                                                    <tr>
                                                        <th>Pendidik</th>
                                                        <th>Mate Pelajaran</th>
                                                        <th>Kelas</th>

                                                    </tr>
                                                </thead>
                                                {/* <tbody>
                                                    {Array.isArray(pembelajaran) &&
                                                        pembelajaran.map((datapembelajaran, index) => (
                                                                            <tr key={"pembelajaran"+index}>
                                                                                <td>{datapembelajaran.nama_guru}</td>
                                                                              <td>{datapembelajaran.jumlah_mapel}</td>
                                                                               <td>{datapembelajaran.jumlah_kelas}</td>
                                                                            </tr>
                                                                     
                                                                    
                                                            ))}

                                                </tbody> */}
                                            </table>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="genrate" role="tabpanel" aria-labelledby="pills-contact-tab">

                                        <div class="row d-flex justify-content-center">
                                            <div class="col-lg-6">
                                                <div class="text-center">
                                                    <i class="ph-duotone ph-gift f-50 text-danger"></i>
                                                   <table className="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Jenis</th>
                                                        <th>Status</th>

                                                    </tr>
                                                </thead>
                                               <tbody>
                                                 <tr>
                                                        <th>Jumlah Jam</th>
                                                        <th>{totaljam}</th>

                                                    </tr>
                                                     <tr>
                                                        <th>Rombongan Belajar</th>
                                                        <th>{totaljam}</th>

                                                    </tr>
                                                      <tr>
                                                        <th>Jumlah Pembelajaran</th>
                                                        <th>Status</th>

                                                    </tr>
                                               </tbody>
                                            </table>
                                                    
                                                    
                                                    <div class="mb-3">
                                                        <div class="form-check d-inline-block">
                                                            <input type="checkbox" class="form-check-input" id="customCheck1" />
                                                            <label class="form-check-label" for="customCheck1">Saya yakin Semua jadwal telah dipesiapkan</label>
                                                        </div>
                                                    </div>
                                                     <div class="previous me-2">
                                                <a href="javascript:void(0);" class="btn btn-secondary">Ganrate Jadwal Otomatis</a>
                                            </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="modalDaftarTarget" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <form onSubmit={handleSubmit} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Pengaturan hari </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='btnTutupModal' aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Hari</label>
                                <input type="text" className="form-control" name="hari" value={formData.hari} onChange={handleChange} disabled />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Jam Miminal</label>
                                <input type="number" className="form-control" name="min_jam" value={formData.min_jam ?? 0} onChange={handleChange} required />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Jam Maximal</label>
                                <input type="number" className="form-control" name="max_jam" value={formData.max_jam ?? 0} onChange={handleChange} required />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Status</label>
                                <Select
                                    options={status}
                                    name="status"
                                    required
                                    getOptionLabel={(e) => e.label}
                                    getOptionValue={(e) => e.value}
                                    value={status.find((opt) => opt.value === formData.status) || null}
                                    onChange={(kelasTerpilih) => {
                                        setFormData({
                                            ...formData,
                                            status: kelasTerpilih.value // hanya ambil stringnya
                                        });
                                    }}
                                    placeholder="Kosongkan Jika Tidak Ada..."
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Batal
                            </button>
                            <button type='submit' className="btn btn-primary">
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div className="modal fade" id="jampembelajaranmodal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <form onSubmit={handleSubmitjamPembalajaran} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Jam Pembelajaran</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id='btnTutupModal' aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Hari</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="hari"
                                    value={formDataJamPembelajaran.hari}
                                    disabled
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Jam Pembelajaran</label>
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Nomor</th>
                                            <th>Jam Mulai</th>
                                            <th>Jam Selesai</th>
                                            <th>Jenis</th>
                                            <th>Hapus</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(formDataJamPembelajaran.list) && formDataJamPembelajaran.list.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="jam_mulai"
                                                        required
                                                        value={item.jam_mulai}
                                                        onChange={(e) => handleJamChange(index, 'jam_mulai', e.target.value)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        name="jam_selesai"
                                                        required
                                                        value={item.jam_selesai}
                                                        onChange={(e) => handleJamChange(index, 'jam_selesai', e.target.value)}
                                                    />
                                                </td>
                                                <td>
                                                    <select
                                                        className="form-select"
                                                        required
                                                        value={item.jenis}
                                                        onChange={(e) => handleJamChange(index, 'jenis', e.target.value)}
                                                    >
                                                        <option value="p">Pembelajaran</option>
                                                        <option value="even">Even</option>
                                                        <option value="istirahat">Istirahat</option>
                                                        <option value="extrakurikuler">Extrakurikuler</option>
                                                        
                                                    </select>
                                                </td>

                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-icon btn-danger"
                                                        onClick={() => handleHapusJam(index)}
                                                    >
                                                        <i className="ti ti-x"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}

                                        <tr>
                                            <td colSpan="4">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary d-inline-flex"
                                                    onClick={()=>{handleTambahJam()}}
                                                >
                                                    <i className="ti ti-plus me-1"></i> Tambah Jam
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Batal
                            </button>
                            <button type="submit" className="btn btn-primary">
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>



        </div>
    );
};

export default Setupjadwal;
